import React from 'react'

function TermsAndConditions() {
    return (
        <div className="container py-5">
            <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4 p-md-5">

                    <h5 className="fw-bold text-success border-bottom pb-3 mb-4">
                        Terms & Conditions
                    </h5>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        This website is designed, developed and maintained by Tamil Nadu Warehousing Corporation (TNWC). Though all efforts have been
                        made to ensure the accuracy and currency of the content on this website, the same should not be construed as a statement of law or
                        used for any legal purposes. In case of any ambiguity or doubts, users are advised to verify/check with the Corporation, and to obtain
                        appropriate professional advice. Under no circumstances will this Corporation be liable for any expense, loss or damage including,
                        without limitation, indirect or consequential loss or damage, or any expense, loss or damage whatsoever arising from use, or loss of use,
                        of data, arising out of or in connection with the use of this website. These terms and conditions shall be governed by and construed in
                        accordance with the Indian/ Tamil Nadu Laws. Any dispute arising under these terms and conditions shall be subject to the jurisdiction
                        of the courts of India/ Tamil Nadu. The information posted on this website could include hypertext links or pointers to information created
                        and maintained by non-Government/private organisations. (CWC, WDRA) is providing these links and pointers solely for your information
                        and convenience. When you select a link to an outside website, you are leaving the website and are subject to the privacy and security
                        policies of the owners/sponsors of the outside website. Tamil Nadu State Warehousing Corporation does not guarantee the availability of
                        such linked pages at all times.
                    </p>
                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        Tamil Nadu Warehousing Corporation, cannot authorise the use of copyrighted materials contained in linked websites. Users
                        are advised to request such authorisation from the owner of the linked website. Tamil Nadu Warehousing Corporation, does not guarantee
                        that linked websites comply with Indian Government or Tamil Nadu Web Guidelines.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default TermsAndConditions